import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { RootContext } from "./RootContextProvider";
import Signin from "../src/components/login/Login";
import Signup from "../src/components/signup/Signup";
import App from "../src/AppGlobal/App.jsx";
import AccountValidation from "../src/components/accountValidation/AccountValidation";
import Forgot from "../src/components/forgotPassword/ForgotPassword";
import ResetPassword from "../src/components/forgotPassword/ResetPassword";
// import CustomPage from "../src/components/customPage/CustomPage";
import TagManager from "react-gtm-module";
class Root extends Component {
  componentWillMount() {
    const { setToken } = this.context;
    const localToken = localStorage.getItem("userToken");
    setToken(localToken);
  }
  componentDidMount() {
    // CHAT BOT
    // window.$crisp = [];
    // window.CRISP_WEBSITE_ID = "5208a145-d99d-42fe-8e0c-0ecbbe47437d";

    // (function () {
    //   var d = document;
    //   var s = d.createElement("script");

    //   s.src = "https://client.crisp.chat/l.js";
    //   s.async = 1;
    //   d.getElementsByTagName("head")[0].appendChild(s);
    // })();
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      // dev code
    } else {
      TagManager.initialize({ gtmId: "GTM-53PT4FZ" });
    }
  }

  render() {
    const { token, isTokenLoaded } = this.context;
    return (
      <Switch>
        <Route
          path="/validation/:id"
          exact
          strict
          component={AccountValidation}
        />
        <Route path="/validation" component={AccountValidation} />
        <Route path="/forgot-password" exact strict component={Forgot} />
        <Route
          path="/reset-password/:id"
          exact
          strict
          component={ResetPassword}
        />
        <Route path="/reset-password" component={ResetPassword} />
        <Route
          path="/signin"
          render={(props) =>
            !token ? (
              <Signin />
            ) : (
              <Redirect
                to={{ pathname: "/", state: { from: props.location } }}
              />
            )
          }
        />
        <Route
          path="/signup"
          render={(props) =>
            !token ? (
              <Signup />
            ) : (
              <Redirect
                to={{ pathname: "/", state: { from: props.location } }}
              />
            )
          }
        />

        <Route
          path="/"
          render={(props) =>
            token ? (
              <App />
            ) : isTokenLoaded ? (
              <Redirect
                to={{ pathname: "/signin", state: { from: props.location } }}
              />
            ) : (
              <App />
            )
          }
        />
        {/* <Redirect path="/" exact to="/links/" /> */}
      </Switch>
    );
  }
}

Root.contextType = RootContext;

export default Root;
